// API Configuration
// This file centralizes API URL configuration for the application

// API URL for axios requests (includes /api/v1 suffix)
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.azalega-academy.com/api/v1';

// Backend URL for static assets (images, files, etc.) - without /api/v1 suffix
export const BACKEND_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace('/api/v1', '')
  : 'https://api.azalega-academy.com';

// Export default object with all URLs
export default {
  API_URL,
  BACKEND_URL
};
